import React from 'react';

import { Button } from 'shadcn/components/ui/Button';

/**
 * Recommended action section for a projected issue
 * Shows system recommendation and apply button
 *
 * @param {Object} props
 * @param {string} props.recommendedAction - Action type: "TRANSFER", "BUY"
 * @param {number} props.quantity - Quantity of the issue
 * @param {string} props.issueType - Type of issue: "Short", "Overflow"
 * @param {string} props.issueChannel - Channel with issue: "Wholesale", "First Party"
 * @param {Function} [props.onApply] - Callback when Apply button is clicked
 */
export function ProjectedIssueRecommendedAction({ issueChannel, issueType, onApply, quantity, recommendedAction }) {
    // Generate recommendation text based on action type and context
    const generateRecommendationText = () => {
        if (recommendedAction === 'TRANSFER') {
            const oppositeChannel = issueChannel === 'Wholesale' ? 'First Party' : 'Wholesale';

            const transferFrom = issueType === 'Short' ? oppositeChannel : issueChannel;
            const transferTo = issueType === 'Short' ? issueChannel : oppositeChannel;

            let msg = `${issueChannel} projected ${issueType.toLowerCase()} of ${quantity.toLocaleString()} units. `;
            msg += `Transfer ${quantity.toLocaleString()} units from ${transferFrom} to ${transferTo}.`;
            return msg;
        }
        return 'No recommendation available';
    };

    const actionText = generateRecommendationText();

    return (
        <div className="bg-[#f4f2ea] border-1 border-gray-400 p-4 rounded-lg text-left">
            <div className="flex justify-between items-start gap-4">
                <div className="flex-1">
                    <div className="text-sm text-gray-600 mb-2">System Recommendation:</div>
                    <div className="text-base text-gray-900">{actionText}</div>
                </div>
                <Button
                    type="button"
                    onClick={onApply}
                    className="px-4 py-2 bg-white border-1 border-gray-600 rounded-lg text-sm text-gray-900 hover:bg-gray-50 flex items-center gap-2 whitespace-nowrap"
                >
                    <span className="text-lg">✦</span> Apply
                </Button>
            </div>
        </div>
    );
}
